/**
 * @public
 */
const isEmitOptions = (candidate) => (candidate === null || candidate === void 0 ? void 0 : candidate.hasOwnProperty('bubbles')) ||
    (candidate === null || candidate === void 0 ? void 0 : candidate.hasOwnProperty('cancelable')) ||
    (candidate === null || candidate === void 0 ? void 0 : candidate.hasOwnProperty('composed'));
/**
 * @public
 */
export const getBaseEmitArgs = (...args) => {
    let [type, detailOrOptions, options] = args;
    let detail = detailOrOptions;
    if (isEmitOptions(detailOrOptions)) {
        options = detailOrOptions;
        detail = undefined;
    }
    if (typeof type !== 'string') {
        throw new Error('$emit event types must be typeof string.');
    }
    return [type, detail, options];
};
/**
 * @public
 */
export const customEvent = (ctx) => ctx.event;
/**
 * @public
 */
export const targetValue = (ctx) => ctx.event.target.value;
/**
 * @example
 * ```ts
 * import { targetChecked } from '@genesislcap/foundation-events';
 * ...
 * <${checkboxTag}
 *   ?checked="${(x) => x.store.formEntry.showPassword}"
 *   @change="${(x, c) => x.$emit('auth-showPassword-changed', targetChecked(c))}"
 *   name="show-password"
 *   data-test-id="show-password"
 * >
 *   Show Password
 * </${checkboxTag}>
 * ```
 *
 * @public
 */
export const targetChecked = (ctx) => ctx.event.target.checked;
/**
 * @public
 */
export const targetFirstSelectedValue = (ctx) => { var _a, _b; return (_b = (_a = ctx.event.target) === null || _a === void 0 ? void 0 : _a.firstSelectedOption) === null || _b === void 0 ? void 0 : _b.value; };
/**
 * @internal
 */
const createChangeEmitter = (valueGetter) => (type, options) => (x, c) => x.$emit(String(type), valueGetter(c), options);
/**
 * `<input>` template emit helper.
 *
 * @remarks
 * In some.template.ts file you create the helper upfront by passing in the full event map.
 *
 * @example
 * ```ts
 * const inputEmit = createInputEmitter<EventMap>();
 * ...
 * <zero-text-field @change="${inputEmit('some-input-changed')}">
 * ```
 *
 * @public
 */
export const createInputEmitter = () => createChangeEmitter(targetValue);
/**
 * `<select>` template emit helper.
 *
 * @remarks
 * In some.template.ts file you create the helper upfront by passing in the full event map.
 *
 * @example
 * ```ts
 * const selectEmit = createSelectEmitter<EventMap>();
 * ...
 * <zero-select @change="${selectEmit('some-select-changed')}">
 * ```
 *
 * @public
 */
export const createSelectEmitter = () => createChangeEmitter(targetFirstSelectedValue);
